import React, { useState, useEffect } from "react";
import { Laptop, Palette, Server, Cloud } from "lucide-react";

const services = [
  {
    title: "Full-Stack Development",
    description:
      "Building complete web apps from scratch smooth frontend solid backend and everything in between.",
    icon: <Laptop className="w-8 h-8 text-blue-500" />,
  },
  {
    title: "Frontend Specialization",
    description:
      "Designing modern responsive UIs with React Next.js and Tailwind pixel-perfect and user-friendly.",
    icon: <Palette className="w-8 h-8 text-purple-500" />,
  },
  {
    title: "Backend Solutions",
    description:
      "Creating powerful APIs and scalable backends using Node.js MongoDB SQlite and more.",
    icon: <Server className="w-8 h-8 text-green-500" />,
  },
  {
    title: "Cloud Deployment",
    description:
      "Deploying apps the right way fast secure and optimized on AWS Vercel Netlify and beyond.",
    icon: <Cloud className="w-8 h-8 text-sky-500" />,
  },
  {
    title: "AI Agent Development",
    description:
      "Building intelligent agents and applications using cutting-edge AI technologies and frameworks.",
    icon: <Cloud className="w-8 h-8 text-sky-500" />,
  },
];

const SkillsPage = () => {
  const [isLoaded, setIsLoaded] = useState(false);

  useEffect(() => {
    setIsLoaded(true);
  }, []);

  return (
    <section
      className={`mt-24 md:mt-32 min-h-screen transition-filter duration-1000 ${
        isLoaded ? "filter-none" : "blur-sm"
      }`}
    >
      <div className="max-w-5xl mx-auto px-4 sm:px-8 py-12">
        {/* Value Proposition */}
        <div className="text-center mb-16">
          <div className="flex flex-col items-center">
            <span className="px-5 py-1 bg-blue-100 dark:bg-blue-900/30 text-blue-700 dark:text-blue-300 rounded-full text-sm font-medium mb-4">
              Technical Expertise
            </span>
          </div>
          <div className="max-w-2xl mx-auto">
            <p className="text-2xl text-gray-700 dark:text-gray-300 mb-4 font-semibold">
              I enjoy turning tricky ideas into simple, useful digital tools.
            </p>
            <p className="text-gray-600 dark:text-gray-400 max-w-xl mx-auto">
              I'm a full-stack developer who builds apps that work well and feel
              great to use. Whether it's designing a clean, responsive interface
              or setting up a solid backend, I focus on creating things that are
              fast, reliable, and user-friendly.
            </p>
          </div>
        </div>

        <div className="mb-16">
          <h3 className="text-3xl font-bold mb-10 text-center">
            <span className="pb-2 border-b-2 border-blue-500">
              Services I Offer
            </span>
          </h3>

          {/* Custom grid to put 5th service in the middle */}
          <div className="flex flex-wrap justify-center gap-10">
            {services.map((service, index) => (
              <div
                key={service.title}
                className={`bg-zinc-50 dark:bg-zinc-900 border border-zinc-200 dark:border-zinc-800 rounded-2xl p-8 transition-all duration-300 hover:border-blue-500 hover:shadow-2xl hover:shadow-blue-500/10 group relative overflow-hidden flex flex-col gap-2 ${
                  index < 4
                    ? "w-full md:w-[calc(50%-1.25rem)]"
                    : "w-full md:w-96 md:max-w-md"
                }`}
              >
                <div className="absolute top-0 right-0 h-32 w-32 bg-gradient-to-bl from-blue-500/10 to-transparent rounded-bl-full -mr-16 -mt-16 pointer-events-none"></div>
                <div className="flex items-center mb-3">
                  {service.icon}
                  <h4 className="text-xl font-bold ml-4 text-gray-800 dark:text-gray-100 group-hover:text-blue-600 dark:group-hover:text-blue-400 transition-colors">
                    {service.title}
                  </h4>
                </div>
                <p className="text-gray-700 dark:text-gray-300 leading-relaxed">
                  {service.description}
                </p>
              </div>
            ))}
          </div>
        </div>
        <div className="text-center mb-8">
          <div className="inline-block relative">
            <div className="absolute inset-0 bg-gradient-to-r from-blue-500/10 to-purple-500/10 dark:from-blue-500/20 dark:to-purple-500/20 blur-2xl rounded-2xl"></div>
            <div className="relative backdrop-blur-sm rounded-2xl p-8 border border-gray-200/50 dark:border-gray-800/50 bg-white/60 dark:bg-zinc-900/60">
              <p className="text-lg text-gray-700 dark:text-gray-300">
                I love solving problems and writing code that’s clean and easy
                to work with. If you’ve got an idea, let’s bring it to life
                together.
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default SkillsPage;
